// src/components/receipt/Receipt.styled.ts
//
// Estilos do cupom não fiscal (impressora térmica 80mm). Tudo aqui usa
// preto puro (#000) em vez de tons de cinza — em impressora térmica,
// cinza/opacidade reduzida sai "lavado". Cor/negrito nunca dependem do
// tema claro/escuro do app: o cupom é sempre preto sobre branco.

import styled from "styled-components";

export const ReceiptWrapper = styled.div`
  box-sizing: border-box;
  width: 80mm;
  margin: 0 auto;
  padding: 5mm 4.5mm 10mm;
  background: #fff;
  color: #000;
  font-family: "Courier New", Courier, monospace;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
`;

export const StoreName = styled.h1`
  margin: 0 0 1.5mm;
  font-size: 15px;
  font-weight: 800;
  text-align: center;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  line-height: 1.25;
`;

export const StoreLine = styled.p`
  margin: 0;
  font-size: 10.5px;
  font-weight: 600;
  text-align: center;
  line-height: 1.5;
`;

export const HardDivider = styled.div`
  border-top: 1.6px solid #000;
  margin: 3mm 0;
`;

export const DashedDivider = styled.div`
  border-top: 1.3px dashed #000;
  margin: 3mm 0;
`;

export const Badge = styled.div`
  margin: 0 auto 3mm;
  width: fit-content;
  padding: 1.5mm 4mm;
  border: 1.3px solid #000;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-align: center;
`;

export const ClientBlock = styled.p`
  margin: 1.5mm 0 0;
  font-size: 10.5px;
  font-weight: 600;
  text-align: center;
  line-height: 1.5;
`;

export const DueDateNotice = styled.div`
  margin: 3mm 0 0;
  padding: 1.5mm 3mm;
  border: 1.3px dashed #000;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
`;

export const MetaGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1mm 3mm;
  font-size: 10.5px;
  font-weight: 600;
  line-height: 1.6;

  b {
    font-weight: 800;
  }
`;

export const ItemsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 10.5px;

  thead th {
    text-align: left;
    font-weight: 800;
    font-size: 9.5px;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    border-bottom: 1.3px solid #000;
    padding-bottom: 1.5mm;
  }

  thead th:not(:first-child) {
    text-align: right;
    padding-left: 9px;
  }

  tbody td {
    padding: 1.6mm 0;
    vertical-align: top;
    font-weight: 600;
  }

  /* Gutter fixo entre colunas: sem isso, com border-collapse e sem padding
     horizontal, valores grandes (ex.: R$15.453,00) colam direto no vizinho
     — "1717R$9,00R$15.453,00" — porque a coluna encolhe exatamente até o
     tamanho do conteúdo. O gutter garante respiro mínimo mesmo quando o
     número cresce, ao custo de espremer um pouco mais a coluna Descrição
     (que já quebra linha via ItemName). */
  tbody td:not(:first-child) {
    text-align: right;
    white-space: nowrap;
    padding-left: 9px;
  }

  tbody tr:not(:last-child) td {
    border-bottom: 1px dotted #000;
  }
`;

export const ItemName = styled.div`
  font-weight: 700;
  word-break: break-word;
`;

export const ItemDiscountTag = styled.div`
  margin-top: 0.5mm;
  font-size: 9px;
  font-weight: 700;
`;

export const TotalsBlock = styled.div`
  font-size: 11px;
  font-weight: 600;
`;

export const TotalsRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.8mm 0;
`;

export const GrandTotalBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-top: 2mm;
  padding: 2.5mm 0;
  border-top: 1.8px solid #000;
  border-bottom: 1.8px solid #000;

  span:first-child {
    font-size: 12px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  span:last-child {
    font-size: 17px;
    font-weight: 900;
  }
`;

export const Footer = styled.div`
  margin-top: 4mm;
  text-align: center;
`;

export const ThanksLine = styled.p`
  margin: 0 0 1mm;
  font-size: 12px;
  font-weight: 800;
`;

export const FooterNote = styled.p`
  margin: 0;
  font-size: 9.5px;
  font-weight: 600;
`;

export const QrCodeWrap = styled.div`
  display: flex;
  justify-content: center;
  margin: 4mm 0 3mm;
`;

export const FiscalNote = styled.p`
  margin: 0;
  font-size: 8.5px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.03em;
`;
